if (!customElements.get('pakiki-size-guide')) {
  customElements.define('pakiki-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.sizeOptionIndex === '') return;
      this.productInfo = this.closest('product-info');
      this.onOptionChange = (event) => {
        if (!event.target.closest('variant-selects')) return;
        const groups = this.productInfo.querySelectorAll('variant-selects .product-form__input');
        const group = groups[Number(this.dataset.sizeOptionIndex)];
        const selected = group?.querySelector('input:checked, select');
        this.highlight(selected?.value);
      };
      this.productInfo?.addEventListener('change', this.onOptionChange);
    }

    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onOptionChange);
    }

    highlight(size) {
      this.querySelectorAll('tr[data-size]').forEach((row) => {
        const selected = row.dataset.size === size;
        if (selected) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
        row.querySelector('.pakiki-size-guide__selected').hidden = !selected;
      });
    }
  });
}
